//https://usehooks.com/useLocalStorage/
import { useState } from 'react';
import { isBrowser } from '../utils/environment';
import * as Cookies from '../utils/Cookies';

export function useCookie(key, initialValue) {
    const isServer = !isBrowser();
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = useState(() => {
        if (isServer) {
            return initialValue;
        }

        try {
            // Get from cookies by key
            const item = Cookies.readCookie(key);

            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            // eslint-disable-next-line
            console.log(error);

            return initialValue;
        }
    });

    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    const setValue = (value) => {
        try {
            // Allow value to be a function so we have same API as useState
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            // Save state
            setStoredValue(valueToStore);

            // Save to local storage
            if (!isServer) {
                const item = Cookies.readCookie(key);

                if (item) {
                    Cookies.eraseCookie(key);
                }

                Cookies.createCookie(key, JSON.stringify(value));
            }
        } catch (error) {
            // eslint-disable-next-line
            console.log(error);
        }
    };

    return [storedValue, setValue];
}
